import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import NadaConsta from "../../../components/nadaConsta";

export default function PassagensComerciais({
  passagens
}: {
  passagens: any
}) {
  const { t } = useTranslation();

  const temOcorrencias = passagens && passagens.OCORRENCIAS && passagens.OCORRENCIAS.length > 0;

  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {temOcorrencias ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('passagensComerciais')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('passagensComerciais')}</span>)}</div>;
  }

  const getResumo = () => {
    const resumos: any[] = [];
    if (temOcorrencias) {
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Passagens',
        value: passagens.QUANTIDADE_OCORRENCIA || passagens.OCORRENCIAS.length
      });
    }

    return resumos;
  }

  return (
    <Panel headerTemplate={headerTemplate}>
      {!temOcorrencias ? (<NadaConsta />) : (<>
        <div className="flex-consulta  flex-wrap gap-3">
          {getResumo().map((item: any, index: number) => (

            <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
              <div className="flex-consulta  justify-content-between gap-5">
                <div className="flex-consulta  flex-column gap-1">
                  <span style={{ color: 'white' }} className=" text-sm">{item.label}</span>
                  <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
                </div>
                <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                  <i className={item.icon} />
                </span>
              </div>
            </Card>

          ))}
        </div>
        <br></br>
        <DataTable className="mobile-text-left" size="small" value={passagens.OCORRENCIAS} responsiveLayout="stack" breakpoint="960px">
          <Column field="CLIENTE_CONSULTA" header={t('clienteConsulta')}></Column>
          <Column field="CIDADE_UF_CLIENTE" header={t('cidadeUF')}></Column>
          <Column field="DATA_CONSULTA" header={t('dataConsulta')}></Column>
          <Column field="HORA_CONSULTA" header={t('horaConsulta')}></Column>
          <Column field="TELEFONE_CLIENTE" header={t('fone')}></Column>
        </DataTable>
      </>)}
    </Panel>
  )
}
